import React from 'react';
import { Tooltip, IconButton, TooltipProps, styled } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface InfoTooltipProps {
  title: React.ReactNode;
  placement?: TooltipProps['placement'];
  iconColor?: string;
  iconSize?: 'small' | 'medium' | 'large';
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: 'rgba(26, 26, 46, 0.95)',
    color: '#fff',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid rgba(138, 43, 226, 0.3)',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(10px)',
    '& a': {
      color: '#00CC99',
    },
  },
  [`& .MuiTooltip-arrow`]: {
    color: 'rgba(26, 26, 46, 0.95)',
  },
}));

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  title,
  placement = 'top',
  iconColor = 'rgba(0, 204, 153, 0.8)',
  iconSize = 'small',
}) => {
  return (
    <StyledTooltip
      title={title}
      placement={placement}
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={3000}
    >
      <IconButton size={iconSize} sx={{ color: iconColor, p: 0.5 }}>
        <InfoIcon fontSize={iconSize} />
      </IconButton>
    </StyledTooltip>
  );
};

export default InfoTooltip; 